module.exports = __webpack_public_path__ + "static/media/Work_Area_ArrowDown.20d22d7c.svg";